export default {
    parseStoredDataResponse(state, response) {
        state.jqlFilterText = response.jqlFilterText;
        state.wiqlFilterText = response.wiqlFilterText;
        state.jiraFilteringEnabled = response.jiraFilteringEnabled;
        state.azureFilteringEnabled = response.azureFilteringEnabled;
        state.jqlAppendix = response.jqlAppendix;
        state.wiqlAppendix = response.wiqlAppendix;
    },
    toggleJiraFiltering(state) {
        state.jiraFilteringEnabled = !state.jiraFilteringEnabled;
    },
    toggleAzureFiltering(state) {
        state.azureFilteringEnabled = !state.azureFilteringEnabled;
    },
    setJqlQuery(state, query) {
        state.jqlFilterText = query;
    },
    setWiqlQuery(state, query) {
        state.wiqlFilterText = query;
    },
    setJqlTestResult(state, result) {
        state.jqlTestResult = result;
    },
    setWiqlTestResult(state, result) {
        state.wiqlTestResult = result;
    },
    showLoader(state, loaderVisible) {
        state.loaderVisible = loaderVisible;
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/filters/mutations.js